import React, { useReducer } from "react"
import { ProviderProps } from "../types";
import { initialSnackbarState, SnackbarReducer } from "./Actions"
import { SnackDataContext, SnackDispatchContext } from "./Context";

const SnackbarStore: React.FC<ProviderProps> = ({children}) => {
    const [state, dispatch] = useReducer(SnackbarReducer, initialSnackbarState);

    return (
        <SnackDataContext.Provider value={state}>
            <SnackDispatchContext.Provider value={dispatch}>
                {children}
            </SnackDispatchContext.Provider>
        </SnackDataContext.Provider>
    )
}

export default SnackbarStore;